export const COMPONENT_NAME = "settings-kyc-kyb";
